import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper'
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import AppBarInput from '../../../Components/AppBarInput';
import { apiKey, server } from '../../../Config/server';
import { Document, Page, pdfjs } from 'react-pdf';
import sample from '../../../Assets/SK-NASDEM.pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

export default function DetailIntruksi() {
  const { id } = useParams()
  const [detail, setDetail] = useState(null)
  const [file, setFile] = useState('./sample.pdf');
  const [numPages, setNumPages] = useState(null);

  function onFileChange(event) {
    setFile(event.target.files[0]);
  }

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  useEffect(() => {
    // Swal.showLoading()
    // axios({
    //   url: `${server}sarpras/detail/${id}`,
    //   method: 'get',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Authorization: `Bearer ${sessionStorage.token}`,
    //     'x-api-key': apiKey
    //   }
    // })
    //   .then(({ data }) => {
    //     setDetail(data.data)
    //     Swal.close()
    //   })
    //   .catch(err => {
    //     console.log(err);
    //   })
  }, [])

  return (
    <div className='outer-input'>
      <AppBarInput title='Detail Intruksi' />
      <Container maxWidth='md' sx={{ py: '20px' }}>
        <Paper sx={{ borderRadius: '20px', display: 'flex', justifyContent: 'center' }}>
          <Document file={sample} onLoadSuccess={onDocumentLoadSuccess} options={options}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} />
            ))}
          </Document>
        </Paper>
      </Container>
    </div>
  );
}
